import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageServiceService {
confirmMessage$=new Subject<boolean>();
setuserId$=new Subject<any>();
constructor() { }

  setConfirmMessage(data:boolean){
    this.confirmMessage$.next(data);
  }
  getConfirmMessage():Observable<boolean>{
    return this.confirmMessage$.asObservable();
  }
  setuserIdMessage(data:any){
   this.setuserId$.next(data);
  }
  getuserIdMessage():Observable<any>{
    return this.setuserId$.asObservable();
  }
}
